/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "cat-290c3e97--sprite",
  "use": "cat-290c3e97--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"cat-290c3e97--sprite\"><rect width=\"36\" height=\"36\" fill=\"none\" /><g transform=\"translate(-204.111 -176.808)\"><path d=\"M237.625,185.948c-1.073-2.163-.276-5.222-3-6a1.944,1.944,0,0,1,0-2c.185-.381,0-.843-2,0-4.739,2-5.409,4.04-6,9-1.107,7.749-3.6,4.987-9,9-5.12,3.736-4.138,7.157-4,12-8.164-7.057,7.183-13.251,4-21-1.8-4.151-6.679-5.906-10-3-2.076,1.66-1.076,3.384,1,2,2.352-1.937,4.893-.629,6,2,1.66,4.013-5.031,10.264-6,14-1.107,3.736,1.88,10,7,10h10c-.177-.933-.031-1.879-1-2,2.768-2.491,1.862,1.308,2,2h4a2.143,2.143,0,0,0-1-1c-.415-6.919,3.755-8.849,5-13,.83-3.044-1.031-6.232-2-9,1.459-1.061,3.388.532,5-2A1.079,1.079,0,0,0,237.625,185.948Z\" transform=\"translate(0 0)\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
